class EditMenuController {
  /* @ngInject */
  constructor($rootScope, MenuActions, MenuStore, StoreStates) {
    const that = this;

    that.loading = {
      menu: false
    };

    const init = () => {
      if (that.mode === 'create') {
        that.menu = {};
      }
    };

    that.$onInit = init;

    that.saveMenu = () => {
      if (MenuStore.getMenuStoreState() === StoreStates.STORE_PENDING_UPDATE) return;

      switch (that.mode) {
        case 'create':
          that.loading.menu = true;
          MenuActions.createMenu(that.menu);
          break;
        case 'edit':
          that.loading.menu = true;
          MenuActions.editMenu({ description: that.menu.description, name: that.menu.name }, that.menu.id);
          break;
        default:
          break;
      }
    };

    const deregSaveMenuListener = $rootScope.$on('SAVEMENU', that.onCancel);
    const deregSaveMenuFailListener = $rootScope.$on('SAVEMENU_FAIL', () => {
      that.loading.menu = false;
    });

    that.$onDestroy = () => {
      deregSaveMenuListener();
      deregSaveMenuFailListener();
    };
  }
}

export default EditMenuController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/edit/edit.controller.js
 **/